(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jackhammer-public-test"]) return;
  try {
    
  if (document.querySelector('[data-jackhammer-build-handoff]') && !window.Shopify?.designMode) {
    const destination = new URL(window.location.href);
    if (destination.searchParams.get('view') !== 'jackhammer-build') {
      destination.searchParams.set('view', 'jackhammer-build');
      window.location.replace(destination.href);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jw-commission-gallery"] && !Shopify.designMode) return;
  try {
    
function initArchive(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const q=s=>root.querySelector(s),cards=[...root.querySelectorAll('.card')],labels=JSON.parse(q('[data-labels]').textContent),dialog=q('dialog');let category=labels.all,active=null,index=0,opener=null;
 const apply=()=>{let count=0;for(const card of cards){card.hidden=!((category===labels.all||card.dataset.category===category)&&card.dataset.title.toLowerCase().includes(q('[data-search]').value.toLowerCase()));if(!card.hidden)count++}q('[data-count]').textContent=count+' '+(count===1?labels.build:labels.builds);q('[data-empty]').hidden=count>0;};
 for(const name of [labels.all,...new Set(cards.map(c=>c.dataset.category))]){const button=document.createElement('button');button.textContent=name;button.setAttribute('aria-pressed',String(name===category));button.onclick=()=>{category=name;for(const b of q('.gallery-filters').children)b.setAttribute('aria-pressed',String(b===button));apply()};q('.gallery-filters').append(button)}
 const show=()=>{q('[data-large]').src=active.photos[index];q('[data-large]').alt=active.card.dataset.title+' — '+labels.photo+' '+(index+1);q('[data-photo-count]').textContent=(index+1)+' / '+active.photos.length;for(const [i,b] of [...q('.gallery-thumbnails').children].entries())b.setAttribute('aria-current',String(i===index));q('[data-previous]').disabled=q('[data-next]').disabled=active.photos.length<2;};
 for(const card of cards)card.querySelector('.photo-button').onclick=()=>{const photos=JSON.parse(card.querySelector('[data-photos]').textContent);if(!photos.length)return;active={card,photos};index=0;opener=card.querySelector('button');q('[data-viewer-title]').textContent=card.dataset.title;q('[data-viewer-category]').textContent=card.dataset.category;for(const key of ['--border-width','--border-color','--radius'])dialog.style.setProperty(key,card.style.getPropertyValue(key));q('.gallery-thumbnails').replaceChildren();photos.forEach((src,i)=>{const b=document.createElement('button'),img=document.createElement('img');b.setAttribute('aria-label',labels.photo+' '+(i+1));img.src=src+'&width=120';img.alt='';img.loading='lazy';b.append(img);b.onclick=()=>{index=i;show()};q('.gallery-thumbnails').append(b)});show();dialog.showModal();};
 q('[data-next]').onclick=()=>{index=(index+1)%active.photos.length;show()};q('[data-previous]').onclick=()=>{index=(index+active.photos.length-1)%active.photos.length;show()};q('[data-close]').onclick=()=>dialog.close();dialog.addEventListener('close',()=>opener?.focus());dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();q('[data-next]').click()}if(e.key==='ArrowLeft'){e.preventDefault();q('[data-previous]').click()}});q('[data-search]').oninput=apply;apply();
}
document.querySelectorAll('.jw-archive').forEach(initArchive);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.jw-archive').forEach(initArchive));

  } catch(e) { console.error(e); }
})();
})();
